<template>
	<div>
		<el-upload
			action
			:show-file-list="false"
			:http-request="accessory"
			:before-upload="beforeAvatarUpload"
			:accept="accept"
		>
			<slot></slot>
		</el-upload>
	</div>
</template>
<script>
import { conver } from '@/common/util.js';
export default {
	name: 'fileUpload',
	props: {
		type: null,
		accept: null,
	},
	data() {
		return {
			uploadUrl: '',
		};
	},
	methods: {
		//附件类型(1,image;2,audio;3,video;4,file)
		async accessory(param) {
			let fileInfo = {
				name: param.file.name,
				size: param.file.size,
				fileSize: conver(param.file.size),
				filetype: param.file.name.split('.')[1],
				type: this.type, //1.文本消息2.图片，3.视频,4.文件，5弹窗
				url: '',
				sendType: 1, //发送状态(1:发送中;2:发送成功;3:发送失败;)
			};
			this.$emit('upload', fileInfo);
			try {
				let info = await this.$ossService({
					file: param.file,
					folder: '',
				});
				this.uploadUrl =
					'https://iglobalwin-public-resource.oss-cn-hangzhou.aliyuncs.com/' + info.ossName;
				let fileInfo = {
					name: param.file.name,
					size: param.file.size,
					fileSize: conver(param.file.size),
					filetype: info.type,
					type: this.type, //1.文本消息2.图片，3.视频,4.文件，5弹窗
					url: this.uploadUrl,
					sendType: 2, //发送状态(1:发送中;2:发送成功;3:发送失败;)
				};
				this.$emit('upload', fileInfo);
			} catch (err) {
				console.log('上传失败catch----');
				let fileInfo = {
					name: param.file.name,
					size: param.file.size,
					fileSize: conver(param.file.size),
					filetype: param.file.name.split('.')[1],
					type: this.type, //1.文本消息2.图片，3.视频,4.文件，5弹窗
					url: this.uploadUrl,
					sendType: 3, //发送状态(1:发送中;2:发送成功;3:发送失败;)
				};
				this.$emit('upload', fileInfo);
				throw new Error(err);
			}
		},
		beforeAvatarUpload(file) {
			const isImg =
				file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 <= 25;
			if (this.type == 2) {
				if (!isImg) {
					this.$alert('选择的文件必须是图片', '提示', {
						confirmButtonText: '确定',
					});
					return false;
				}
			}
			if (this.type == 4) {
				if (isImg) {
					this.$alert('请选择附件', '提示', {
						confirmButtonText: '确定',
					});
					return false;
				}
			}
			if (!isLt2M && this.type != 2) {
				this.$alert('Facebook最大支持25MB附件', '提示', {
					confirmButtonText: '确定',
				});
				return false;
			}
		},
	},
};
</script>

<style></style>
